import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import waitIcon from '../../../../../../assets/Imagess/calenderVector.svg';
import styles from './RightSideComp.module.css';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextInput from '../../../../../Atoms/Inputs/TextInput';

const WaitingForm = forwardRef(({ selectedNode }, ref) => {
  const waitingRef = useRef();
  const [init, setInit] = useState({});

  const validationSchema = Yup.object().shape({
    wait: Yup.number()
      .required('Waiting days is required')
      .min(0, 'Negative numbers are not allowed'),
  });

  useEffect(() => {
    if (selectedNode) {
      const initialValues = {
        wait: selectedNode?.data?.label?.wait || null,
      };

      if (initialValues.wait !== init.wait) {
        setInit(initialValues);
      }
    }
  }, [selectedNode]);

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      waitingRef.current.submitForm();
    },
    get isValid() {
      return waitingRef.current.isValid;
    },
    get values() {
      return waitingRef.current.values;
    },
  }));

  useEffect(() => {
    ref.current = waitingRef.current;
  }, [ref]);

  return (
    <Formik
      initialValues={init}
      enableReinitialize={true}
      innerRef={waitingRef}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
      }}
      validateOnMount={true}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form>
            <div className={styles['email_container']}>
              <TextInput
                label='Waiting Days'
                placeholder='Enter'
                icon={waitIcon}
                name='wait'
                value={values.wait}
                required={true}
                // text={true}
                onChange={(name, value) => {
                  setFieldValue(name, value);
                }}
                errors={errors.wait}
                touched={touched.wait}
              />
              <span className={styles['error-message']}>{errors.wait}</span>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
});
export default WaitingForm;
